import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { motion } from 'framer-motion';
import {
  Printer,
  Download,
  AlertTriangle,
  Info,
  CheckCircle,
  FileImage,
  ChevronDown,
  ChevronUp,
  AlertOctagon,
  FileText
} from 'lucide-react';
import { fetchProgram } from '../../../utils/axios';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import ProgramScope from './Program_Scope';
import Methodology from '../../assets/img/Report-Images/Report_Methodology.png'
import Process from '../../assets/img/Report-Images/Process.png'
// import VulnerabilityChartDashboard from '../../Customer-part/Dashboard/VULChart_component/VulnerabilityChartDashboard'
import ProgramSummary from '../../Customer-part/Report-Charts/ProgramSummary';
import HTTPService from '../../../utils/axios';
import DOMPurify from 'dompurify';
import './Report-chart.css'
import VulnerabilityChartDashboard from './Charts/Vulnerability_chart/VulnerabilityChartDashboard'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useSelector } from "react-redux";
import { getUserInfo } from "../../../reducers/authSlice";
import { customToast } from "../../../App";
import { toast } from "react-toastify";





const Report = () => {
  const reportref = useRef(null);
  const { invokeApi } = HTTPService();
  const { id } = useParams();
  const [expandedAll, setExpandedAll] = useState(false);
  const [expandedsubmission, setExpandedsubmission] = useState(null);
  const [chartTypes, setChartTypes] = useState({
    progress: 'bar',
    participation: 'pie',
    budget: 'bar'
  });
  const [programList, setProgramList] = useState([]);
  const [submissions, setSubmissions] = useState();
  const [subcount, setSubcount] = useState();
  const uid = localStorage.getItem("userid");
  const [userData, setUserData] = useState();
  // const [ProgramScopee, setProgramScopee] = useState();
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const location = useLocation();
  const { reportdata, reportType, selectSubmission } = location.state || {};
  const navigate = useNavigate();
  const pdfRef = useRef(null);
  const { userAccData } = useSelector(getUserInfo);
  const [isPdfMode, setIsPdfMode] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);




  console.log(reportdata);


  const handleCancel = () => {
    navigate(-1); // Go back
  };

  const handleSaveReport = async () => {
    const input = reportref.current;
    if (!input) return;

    // Step 1: Find all elements that should be hidden only during PDF save
    const elementsToHide = input.querySelectorAll("[data-hide-in-pdf]");

    elementsToHide.forEach(el => el.classList.add("hide-in-pdf")); // Temporarily hide

    setIsPdfMode(true); // 🧨 Trigger "hide mode"

    // Wait a moment to let React re-render with isPdfMode = true
    await new Promise((resolve) => setTimeout(resolve, 100));

    try {
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 205;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, "", "FAST");
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, "", "FAST");
        heightLeft -= pageHeight;
      }

      const pdfBlob = pdf.output("blob");
      const pdfFile = new File([pdfBlob], "report.pdf", { type: "application/pdf" });

      const formData = new FormData();
      formData.append("report", pdfFile);
      formData.append("title", `${report?.program_title}(Executive Report)`);
      formData.append("report_type", "Executive Report");
      formData.append("reference_id", id);
      formData.append("reference_type", "Program");
      formData.append("user_id", userAccData?.id);

      await invokeApi({
        method: "POST",
        url: "/report/",
        data: formData,
      });

      toast.success("PDF uploaded successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Upload failed", error);
      toast.error("Failed to upload PDF!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } finally {
      // Step 2: Revert hidden elements
      elementsToHide.forEach(el => el.classList.remove("hide-in-pdf"));
      setIsPdfMode(false);
    }
  };




  const fetchUser = async () => {
    invokeApi({
      method: "GET",
      url: `customer/${uid}/`,
    })
      .then((data) => {
        setUserData(data);
      })
      .catch((error) => {
        customToast.error("Unable to fetch User Data!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        return null;
      });
  };

  const fetchSubmissions = () => {
    invokeApi({
      method: "GET",
      url: `submissions/`,
      params: {
        program_id: id,
        submission_status: "resolved",
      },
    })
      .then((response) => {
        setSubmissions(response);
        console.log("The Submissions: ", response);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchSubcount = () => {
    invokeApi({
      method: "GET",
      url: `widget/programs-stats/`,
      params: {
        program_id: id,

      },
    })
      .then((response) => {
        setSubcount(response.widget_stats);
        console.log("The Subcount: ", response.widget_stats);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };


  // const fetchProgramScope = () => {
  //   invokeApi({
  //     method: "GET",
  //     url: `programs/`,
  //     params: {
  //       program_id: id,
  //     },
  //   })
  //     .then((response) => {
  //       setProgramScopee(response);
  //       console.log("The Programs: ", response);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };

  const fetchReport = async () => {
    setLoading(true); // Start loading

    try {
      const response = await invokeApi({
        method: "GET",
        url: "programs/",
        params: { id },
      });

      if (response?.results?.length > 0) {
        setReport(response.results[0]);
      } else {
        setError("No report data found for the given ID.");
        setReport(null);
      }
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err?.message ||
        "An unknown error occurred while fetching the report.";

      setError(message);
      setReport(null);
    } finally {
      setLoading(false); // End loading (whether success or failure)
    }
  };

  useEffect(() => {
    fetchSubmissions();
    // fetchProgramScope();
    fetchUser();
    fetchSubcount();
    fetchReport();
  }, [id]);

  {
    loading ? (
      <p>Loading report...</p>
    ) : report ? (
      <div> ...render report... </div>
    ) : error ? (
      <p className="text-danger">{error}</p>
    ) : null;
  }



  useEffect(() => {
    const loadProgramList = async () => {
      setLoading(true);
      try {
        const data = await fetchProgram();
        setProgramList(data);
        console.log(data);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadProgramList();
  }, []);

  const togglesubmission = (id) => {
    setExpandedsubmission((prev) => (prev === id ? null : id));
  };

  const renderSeverityBadge = (severity) => {
    const baseClass = 'badge d-inline-flex align-items-center gap-1';
    switch (severity) {
      case 'Critical':
        return <span className={baseClass} style={{ backgroundColor: '#e53e3e', color: 'white' }}><AlertOctagon size={12} />Critical</span>;
      case 'Severe':
        return <span className={baseClass} style={{ backgroundColor: '#dd6b20', color: 'white' }}><AlertTriangle size={12} />Severe</span>;
      case 'Moderate':
        return <span className={baseClass} style={{ backgroundColor: '#d69e2e', color: 'white' }}><AlertTriangle size={12} />Moderate</span>;
      case 'Low':
        return <span className={baseClass} style={{ backgroundColor: '#38a169', color: 'white' }}><CheckCircle size={12} />Low</span>;
      default:
        return <span className={baseClass} style={{ backgroundColor: '#4299e1', color: 'white' }}><Info size={12} />{severity}</span>;
    }
  };

  const renderPriorityBadge = (priority) => {
    const baseClass = 'badge d-inline-flex align-items-center gap-1';
    const colors = {
      P1: '#e53e3e',
      P2: '#dd6b20',
      P3: '#d69e2e',
      P4: '#90cdf4',
      P5: '#38a169'
    };

    return (
      <span className={baseClass} style={{ backgroundColor: colors[priority] || '#e2e8f0', color: priority === 'P3' ? 'black' : 'white' }}>
        {priority}
      </span>
    );
  };

  const renderFileViewer = (fileUrl) => {
    if (!fileUrl) return <p className="text-muted mb-0">No attachments available</p>;

    const getFileExtension = (url) => url.split('.').pop().split('?')[0].toLowerCase();
    const ext = getFileExtension(fileUrl);
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);

    if (isImage) {
      return <img src={fileUrl} alt="Attachment" style={{ maxWidth: '250px', borderRadius: '6px' }} className="shadow-sm d-block" />;
    }

    return (
      <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2 text-decoration-none">
        <FileText size={16} className="text-primary" />
        <span>View Document</span>
      </a>
    );
  };

  const handlePrint = useReactToPrint({
    content: () => reportref.current,
  });

  const handleDownloadPDF = async () => {
    const input = reportref?.current;
    if (!input) return;


    // setIsDownloading(true);
    // Step 1: Hide elements and activate PDF mode
    const elementsToHide = input.querySelectorAll("[data-hide-in-pdf]");
    elementsToHide.forEach(el => el.classList.add("hide-in-pdf"));
    setIsPdfMode(true);

    // Step 2: Wait for DOM to update
    await new Promise(resolve => setTimeout(resolve, 100));

    try {
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        logging: false
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 205;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, "", "FAST");
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, "", "FAST");
        heightLeft -= pageHeight;
      }

      const filename = `${reportType || 'report'}_report_${(report?.program_title || 'item')
        .replace(/\s+/g, '_')
        .toLowerCase()}.pdf`;

      pdf.save(filename);
    } catch (error) {
      console.error("Failed to download PDF", error);
    } finally {
      // Step 3: Restore UI state
      elementsToHide.forEach(el => el.classList.remove("hide-in-pdf"));
      setIsPdfMode(false);
      // setIsDownloading(false);
    }
  };





  // Get chart options from report data
  // const getProgressChartOption = (type) => {
  //   if (!reportdata || !reportdata.charts || !reportdata.charts.progress) {
  //     return null;
  //   }

  //   // Use the chart data from API
  //   return reportdata.charts.progress[type] || reportdata.charts.progress.default;
  // };

  // const getParticipationChartOption = (type) => {
  //   if (!reportdata || !reportdata.charts || !reportdata.charts.participation) {
  //     return null;
  //   }

  //   // Use the chart data from API
  //   return reportdata.charts.participation[type] || reportdata.charts.participation.default;
  // };

  // const getBudgetChartOption = (type) => {
  //   if (!reportdata || !reportdata.charts || !reportdata.charts.budget) {
  //     return null;
  //   }

  //   // Use the chart data from API
  //   return reportdata.charts.budget[type] || reportdata.charts.budget.default;
  // };

  return (
    <div ref={reportref} className="container my-5 py-4 px-5 bg-white shadow rounded" style={{ maxWidth: '350mm', minHeight: '297mm', fontFamily: 'Verdana, sans-serif' }}>
      {/* Header */}
      <div className="text-center mb-4">
        <div className="report-logo me-sm-1">
          <img src={userData?.display_pic} className="report-logo-image" alt="" />
        </div>
        <h1 className="h3 fw-bold text-dark">
          Executive Report:{" "}
          {reportdata?.program_title || report?.program_title || "Loading..."}
        </h1>
        <p className="text-muted mt-2">Prepared on {new Date().toLocaleDateString()}</p>
      </div>
      <div className="d-flex justify-content-end mb-3">
        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center gap-1 bg-primary"
            type="button"
            // data-bs-toggle="dropdown"
            onClick={handleDownloadPDF}
            aria-expanded="false"
            data-hide-in-pdf
            style={{ color: '#fff' }}
          >
            <Download size={16} />
            Download Report
          </button>
        </div>
      </div>
      {/* Executive Summary */}
      <section className="mb-4">
        <h2 className="h5 fw-semibold text-dark border-bottom pb-2 mb-3">Executive Summary</h2>
        <p
          className="text-body"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              reportdata?.project_description ||
              report?.project_description ||
              'Loading...'
            ),
          }}
        ></p>
      </section>




      {/* Charts Section */}
      <section className="">
        <h2 className="text-2xl font-semibold text-gray-800 mt-6 border-b pb-2">
          {"Program Analytics" || "Loading"}
        </h2>

        <div className="row">
          <div className="col-md-6 col-4">
            <VulnerabilityChartDashboard isPdfMode={isPdfMode} />
          </div>


          <div className="ml-2 border-start chart-height"></div>
          <div className="col-md-5">
            <ProgramSummary isPdfMode={isPdfMode} />
          </div>
        </div>
      </section>

      {/* Program/Submission Scope */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-800  border-b pb-2">
          Program Scope
        </h2>

        <div className="bg-gray-50 p-4 rounded-lg table-responsive">
          <ProgramScope />
        </div>
      </section>



      {/* Implementation Methodology */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b pb-2">Implementation Methodology</h2>
        <img
          src={Methodology}
          alt="Methodology"
          className="d-block mx-auto img-fluid rounded shadow"
          style={{ maxWidth: '800px', height: 'auto' }}
        />
      </section>

      {/* Implementation Process */}
      <section className="mt-4">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b pb-2">Implementation Process</h2>
        <img
          src={Process}
          alt="Process"
          className="d-block mx-auto img-fluid rounded shadow"
          style={{ maxWidth: '800px', height: '350px' }}
        />
      </section>

      {/* Reference Table */}
      <section className="mt-5">
        <h2 className="h4 fw-bold text-dark border-bottom pb-2 mb-4">Reference Tables</h2>

        {/* Severity Rating Table */}
        <div className="mb-4">
          <h3 className="h5 fw-semibold text-dark mb-3">Severity Rating</h3>
          <div className="table-responsive border rounded shadow-sm">
            <table className="table table-hover align-middle mb-0">
              <thead style={{ backgroundColor: '#7f56d9', color: 'white' }}>
                <tr>
                  <th scope="col">Level (Severity)</th>
                  <th scope="col">Description</th>
                  <th scope="col">Example</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{renderSeverityBadge('Low')}</td>
                  <td>Minor issue, low impact</td>
                  <td>Information Disclosure</td>
                </tr>
                <tr>
                  <td>{renderSeverityBadge('Moderate')}</td>
                  <td>Moderate issue, requires attention</td>
                  <td>Missing Security Headers</td>
                </tr>
                <tr>
                  <td>{renderSeverityBadge('Severe')}</td>
                  <td>High impact, exploitable</td>
                  <td>SQL Injection</td>
                </tr>
                <tr>
                  <td>{renderSeverityBadge('Critical')}</td>
                  <td>Severe impact, immediate action</td>
                  <td>RCE (Remote Code Execution)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>


      {/* Priority Rating Table */}
      <section className="mb-5">
        <h3 className="h5 fw-semibold text-dark mb-3">Priority Rating</h3>
        <div className="table-responsive border rounded shadow-sm">
          <table className="table table-hover align-middle mb-0">
            <thead style={{ backgroundColor: '#7f56d9', color: 'white' }}>
              <tr>
                <th scope="col">Priority</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{renderPriorityBadge('P1')}</td>
                <td>Immediate remediation needed (Critical risk)</td>
              </tr>
              <tr>
                <td>{renderPriorityBadge('P2')}</td>
                <td>High importance fix, within short term</td>
              </tr>
              <tr>
                <td>{renderPriorityBadge('P3')}</td>
                <td>Medium importance, schedule for review</td>
              </tr>
              <tr>
                <td>{renderPriorityBadge('P4')}</td>
                <td>Low priority, fix in next cycle</td>
              </tr>
              <tr>
                <td>{renderPriorityBadge('P5')}</td>
                <td>Informational, no action needed</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Key submission Section with Table */}
      <section className="mb-5">
        {/* <div className="mb-3 d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-success"
            onClick={() => {
              setExpandedsubmission(null);
              setExpandedAll(true);

            }}
            data-hide-in-pdf
          >
            Expand All
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => {
              setExpandedsubmission(null);
              setExpandedAll(false);
            }}
            data-hide-in-pdf
          >
            Collapse All
          </button>
        </div> */}
        <h2 className="h5 fw-semibold text-dark border-bottom pb-2 mb-4">Findings</h2>

        {/* Submission Table */}
        <div className="table-responsive border rounded shadow-sm">
          <table className="table table-bordered table-hover align-middle mb-0">
            <thead style={{ backgroundColor: '#7f56d9', color: 'white' }}>
              <tr>
                <th className="text-uppercase small text-white">Submission</th>
                <th className="text-uppercase small text-white">Severity</th>
                <th className="text-uppercase small text-white">Priority</th>
                {/* <th className="text-uppercase small text-white">Details</th> */}
              </tr>
            </thead>
            <tbody>
              {submissions?.results ? (
                submissions.results.map((submission) => (
                  <tr key={submission.submission_id}>
                    <td>{submission.submission_title}</td>
                    <td>{renderSeverityBadge(submission.severity)}</td>
                    <td>{renderPriorityBadge(submission.priority)}</td>
                    {/* <td>
                      {console.log(submission)}
                      <button
                        onClick={() => togglesubmission(submission.submissions_id)}
                        className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                      >
                        {(expandedsubmission === submission.submissions_id || expandedAll) ? (
                          <>
                            <ChevronUp size={16} className="me-1" />
                            Hide Details
                          </>
                        ) : (
                          <>
                            <ChevronDown size={16} className="me-1" />
                            View Details
                          </>
                        )}
                      </button>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center text-muted py-3">
                    Findings will be loaded from API
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Expanded Submission Details */}
        {/* {submissions?.results &&
          submissions.results.map((submission) => (
            <motion.div
              key={submission.submissions_id}
              initial={{ opacity: 0, height: 0 }}
              animate={{
                opacity:
                  expandedsubmission === submission.submissions_id || expandedAll ? 1 : 0,
                height:
                  expandedsubmission === submission.submissions_id || expandedAll ? "auto" : 0,
              }}
              transition={{ duration: 0.3 }}
              className={`bg-light rounded border p-4 mb-4 overflow-hidden ${expandedsubmission === submission.submissions_id || expandedAll
                ? "d-block"
                : "d-none"
                }`}
            >
              <h3 className="h6 fw-bold text-dark mb-3 d-flex flex-wrap gap-2 align-items-center">
                {submission.submission}
                <span>{renderSeverityBadge(submission.severity)}</span>
                <span>{renderPriorityBadge(submission.priority)}</span>

              </h3>

              <div className="mb-3">
                <h3 className="fw-bold">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(submission.submission_title),
                    }}
                  ></span>
                </h3>
              </div>

              <div className="mb-3">
                <h5 className="fw-semibold text-secondary mb-2">
                  Detailed Description
                </h5>
                <p className="text-muted">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(submission.detail_description),
                    }}
                  ></span>
                </p>
              </div>

              <div className="mb-3">
                <h5 className="fw-semibold text-secondary mb-2">
                  Steps to Reproduce
                </h5>
                <pre className="bg-body-secondary p-3 rounded text-muted small">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(submission.step_to_reproduce),
                    }}
                  ></span>
                </pre>
              </div>

              <div className="mb-3">
                <h5 className="fw-semibold text-secondary mb-2">
                  Remediation Recommendation
                </h5>
                <p className="text-muted">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        submission.remediation_recommendation
                      ),
                    }}
                  ></span>
                </p>
              </div>

              <div className="mb-3">
                <h5 className="fw-semibold text-secondary mb-2">Attachments</h5>
                {Object.keys(submission)
                  .filter(key => key.startsWith('attachments_upload_doc') && submission[key])
                  .length > 0 ? (
                  <ul className="ps-3 text-muted">
                    {Object.entries(submission)
                      .filter(([key, value]) => key.startsWith('attachments_upload_doc') && value)
                      .map(([key, value]) => (
                        <li key={key} className="d-flex align-items-center gap-2 mb-1">
                          <FileImage size={0} className="text-primary" />
                          {renderFileViewer(value)}
                        </li>
                      ))}
                  </ul>
                ) : (
                  <p className="text-muted">No attachments available</p>
                )}
              </div>

              <div>
                <h5 className="fw-semibold text-secondary mb-2">Evidence Attachments</h5>

                {Object.keys(submission)
                  .filter(key => key.startsWith('evidence_attachments') && submission[key]?.length > 0)
                  .length > 0 ? (
                  <div className="row g-3">
                    {Object.entries(submission)
                      .filter(([key, value]) => key.startsWith('evidence_attachments') && value?.length > 0)
                      .map(([key, value], index) => (
                        <div key={index} className="col-md-6">
                          <li key={key} className="d-flex align-items-center gap-2 mb-1">
                            <FileImage size={0} className="text-primary" />
                            {renderFileViewer(value)}
                          </li>
                        </div>
                      ))}
                  </div>
                ) : (
                  <p className="text-muted">No evidence attachments available</p>
                )}
              </div>

            </motion.div>
          ))} */}
      </section>


      {/* Conclusion */}
      <section className="mb-5">
        <h2 className="h5 fw-semibold text-dark border-bottom pb-2 mb-3">Conclusion</h2>
        <p className={{ fontFamily: "Verdana", fontSize: "18px" }}>
          {`This report outlines the Findings made for the ${report?.program_title} program. Each Findings directly addresses issues identified by the client, offering tailored solutions to various security vulnerabilities. In total, ${submissions?.total_records} Findings were recorded, highlighting active participation from researchers. These efforts not only validate the scope of identified threats but also demonstrate a commitment to securing the assets defined within the program. The collaboration effectively bridges identified risks with actionable remediations.`}
        </p>

      </section>
      <footer className="text-center text-muted small mt-5 pt-4 border-top">
        <p className="mb-0">© 2025. BugBustersLabs Private Limited .All Rights Reserved</p>
      </footer>

      {/* <footer className="text-muted small mt-5 pt-4 border-top">
  <div className="d-flex justify-content-between align-items-center px-3">
    <span className="fw-semibold">© 2025. BugBustersLabs Private Limited .All Rights Reserved</span>
    <span>{report?.customer_details.entity_name || 'Loading name...'}</span>
  </div>
</footer> */}

      <div className="d-flex justify-content-center gap-2 mt-3 px-3">
        <button
          style={{ backgroundColor: '#7f56d9', color: 'white' }}
          className="btn px-4 py-2 rounded"
          onClick={handleCancel}
          data-hide-in-pdf
        >
          Cancel
        </button>

        <button
          style={{ backgroundColor: '#7f56d9', color: 'white' }}
          className="btn px-4 py-2 rounded"
          onClick={handleSaveReport}
          data-hide-in-pdf
        > Save Report
        </button>
      </div>
      {/* {isDownloading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex justify-content-center align-items-center" style={{ zIndex: 9999 }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }} />
            <div className="mt-3 fs-5">Generating PDF...</div>
          </div>
        </div>
      )} */}


    </div>
    
  );
};

export default Report;
